interface FacebookProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const Facebook = ({ className = '', ...props }: FacebookProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 27.82 54.5"
      fill="none"
      className={className}
      {...props}
    >
      <path
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        d="M25.73,30.17l2.09-9.09h-9.44v-6.21c0-2.54,1.39-5.29,5.04-5.29h4.4V0h-6.63c-9.39,0-13.84,5.58-13.84,13.53v7.54H0v9.1h7.35v23.68c2.12.42,4.31.64,6.56.64,1.52,0,3.01-.11,4.47-.3v-24.02h7.35Z"
      />
    </svg>
  );
};

export default Facebook;
